import Logo from "../styles/AXPO_LOGO_CMYK_NEW.png";
const AuthLoader = () => {
  return (
    <div className="full-page-loader">
      <img width="200" alt="axpoLogo" src={Logo} />
    </div>
  );
};
export default AuthLoader;
